import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { errorCheck } from '@root/utils/error-check';
import { map } from 'rxjs/operators';
import { MERCHANT_COMMENT_TYPE } from '@root/resources/enums/merchant-comment-types.enum';
import { HttpService } from '@services/http.service';

@Injectable({
  providedIn: 'root'
})
export class UserDetailService {

  constructor(
    private http: HttpService
  ) { }

  getUserDetail(userId) {
    if(userId){
    return this.http.get(`${environment.API_URL}/api/user/${userId}/detail`)
      .pipe(
        map(res => errorCheck(res)),
        map(
          res => res.result,
          error => { throw error; }
        )
      );
      }
  }
}
